import {Component} from '@angular/core';

@Component({
  selector: 'mc-drawer-card-title',
  templateUrl: './drawer-card-title.component.html',
  styleUrls: ['./drawer-card-title.component.scss'],
})
export class DrawerCardTitleComponent {}
